<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  installments: { type: Array, default: () => [] },
  showExpectedOn: { type: Boolean, default: true },
});
const { t } = useI18n();
const money = value => value?.amount || value || t('SALES.DETAIL.EMPTY_VALUE');
const date = value => {
  if (!value) return t('SALES.DETAIL.EMPTY_VALUE');

  const parsed = new Date(`${value}T00:00:00Z`);
  return Number.isNaN(parsed.getTime())
    ? value
    : new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(parsed);
};
</script>

<template>
  <div
    v-if="!installments.length"
    class="rounded-lais-sm border border-dashed border-lais-border p-4 text-sm text-lais-text-muted"
  >
    {{ t('SALES.DETAIL.COMMISSION.NO_INSTALLMENTS') }}
  </div>
  <div v-else class="overflow-x-auto">
    <table class="min-w-[620px] w-full text-left text-sm">
      <thead
        class="border-b border-lais-border-soft text-xs uppercase tracking-wide text-lais-text-muted"
      >
        <tr>
          <th class="px-3 py-2 font-bold">
            {{ t('SALES.DETAIL.COMMISSION.INSTALLMENT') }}
          </th>
          <th class="px-3 py-2 font-bold">
            {{ t('SALES.DETAIL.COMMISSION.VALUE') }}
          </th>
          <th class="px-3 py-2 font-bold">
            {{ t('SALES.DETAIL.COMMISSION.PAYMENT_PERIOD') }}
          </th>
          <th v-if="showExpectedOn" class="px-3 py-2 font-bold">
            {{ t('SALES.DETAIL.COMMISSION.EXPECTED_ON') }}
          </th>
        </tr>
      </thead>
      <tbody class="divide-y divide-lais-border-soft text-lais-text-body">
        <tr v-for="installment in installments" :key="installment.id">
          <td class="px-3 py-3">
            {{ installment.numero_parcela || t('SALES.DETAIL.EMPTY_VALUE') }}
          </td>
          <td class="px-3 py-3">{{ money(installment.valor_parcela) }}</td>
          <td class="px-3 py-3">
            {{ installment.periodo_pagamento || t('SALES.DETAIL.EMPTY_VALUE') }}
          </td>
          <td v-if="showExpectedOn" class="px-3 py-3">
            {{ date(installment.dia_pagamento) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
